import { render, staticRenderFns } from "./IP_PsiSummaryPrintable.vue?vue&type=template&id=b9466326&scoped=true&"
import script from "./IP_PsiSummaryPrintable.vue?vue&type=script&lang=js&"
export * from "./IP_PsiSummaryPrintable.vue?vue&type=script&lang=js&"
import style0 from "./IP_PsiSummaryPrintable.vue?vue&type=style&index=0&id=b9466326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9466326",
  null
  
)

export default component.exports